

const AudioDisplay = ({name="",size=0, progress=0}) => {

    return (
            <div className="flex-1 flex-row items-center relative border border-gray rounded-md w-full px-2 h-full">
                <div>
                    <p className="break-all">
                        {/* {`${prev?.name.slice(0,18)}...`} */}
                        {name.replace?.(/\.[0-9a-zA-Z]+$/gi, "")}
                      </p>
                </div>
                <div className="flex space-x-2 items-center">
                    <span className="w-14 text-sm text-darkerGray font-semiBold">
                        {size}
                    </span>
                    {progress > 1 && (
                      <div className="w-full flex items-center">
                        <div className="bg-thBg h-2 rounded-full w-full mr-2">
                          <div
                            className={`h-2 rounded-full ${
                              progress === 100
                                ? "bg-lightGreen"
                                : "bg-primary"
                            }`}
                            style={{ width: `${progress}%` }}
                            id="serverProgress"
                          ></div>
                        </div>
                        {
                          progress > 1 && 
                          <span className="w-11 flex justify-end">
                            {progress}%
                          </span>
                        }
                      </div>
                    )}
                </div>
            </div>
    )
}

export default AudioDisplay;